import React, {useState} from 'react'
import {
  DialogContent,
  Typography,
  DialogActions,
  Button,
  Dialog,
  IconButton,
  Icon,
  Checkbox,
} from '@material-ui/core'
import {makeStyles} from '@material-ui/styles'

const useStyles = makeStyles(() => ({
  checkContainer: {
    display: 'flex',
    padding: '16px 0 0',
    alignItems: 'center',
  },
  checkbox: {padding: 5, marginRight: 10},

  content: {
    borderTop: '1px solid rgba(0, 0, 0, 0.12)',
    padding: 24,
    fontFamily: 'Muli',
  },
  btnDel: {
    backgroundColor: '#ef4d5e',
    marginLeft: 10,
    color: '#fff',
    '&:hover': {
      backgroundColor: '#ef4d5e',
    },
  },
  actions: {paddingRight: 24, paddingBottom: 24},
  wordBreak: {wordBreak: 'break-all'},
  whiteHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px 24px',
  },
}))

export default function DeletePopup(props) {
  const classes = useStyles()
  const {
    open,
    handleClose,
    name = '',
    mutation,
    title,
    message,
    checkboxMessage,
    isClose = true,
  } = props
  const [checked, setChecked] = useState(false)
  const handleChange = e => setChecked(e.target.checked)

  const handleCloseAction = () => {
    handleClose()
    setChecked(false)
  }

  return (
    <Dialog onClose={handleCloseAction} open={open} fullWidth maxWidth="xs">
      <div className={classes.whiteHeader}>
        <Typography
          variant="subtitle1"
          color="error"
          className={classes.wordBreak}
        >
          {title || `Delete ${name}?`}
        </Typography>
        <IconButton
          style={{...(!isClose && {display: 'none'})}}
          aria-label="close"
          onClick={handleCloseAction}
        >
          <Icon>close</Icon>
        </IconButton>
      </div>
      <DialogContent className={classes.content}>
        <Typography variant="caption">
          {message || (
            <>
              <Typography variant="caption" display="inline">
                Apakah Anda yakin ingin menghapus
              </Typography>
              <Typography
                variant="caption"
                color="error"
                display="inline"
                className={classes.wordBreak}
              >
                {' '}
                {name}{' '}
              </Typography>
              <Typography variant="caption" display="inline">
                secara permanen?
              </Typography>
            </>
          )}
        </Typography>
        <div className={classes.checkContainer}>
          <Checkbox
            checked={checked}
            onChange={handleChange}
            color="primary"
            className={classes.checkbox}
          />
          <Typography variant="caption">
            {checkboxMessage ||
              'Saya memahami bahwa penghapusan file ini bersifat permanen dan tidak dapat diurungkan. Tindakan ini juga akan menghapus komentar dalam hal ini.'}
          </Typography>
        </div>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button style={{fontSize: 12}} onClick={handleCloseAction}>
          Batal
        </Button>
        <Button
          style={{fontSize: 12}}
          className={classes.btnDel}
          disabled={!checked}
          variant="contained"
          onClick={() => {
            setChecked(false)
            handleClose()
            mutation()
          }}
        >
          Hapus
        </Button>
      </DialogActions>
    </Dialog>
  )
}
